import { createFileRoute } from "@tanstack/react-router";
import RatgeberPage from "@/pages/RatgeberPage";
import { buildRouteHead } from "@/lib/route-head";
import { blogSchema } from "@/lib/schema";
import { insights } from "@/data/insights";

const sortedInsights = [...insights].sort(
  (a, b) =>
    new Date(b.datePublished).getTime() - new Date(a.datePublished).getTime(),
);

export const Route = createFileRoute("/ratgeber/")({
  head: () =>
    buildRouteHead({
      title: "Ratgeber | Webdesign & SEO-Wissen aus Wernigerode",
      description:
        "Praxisnaher Ratgeber zu Webdesign, SEO, Performance und Digitalisierung. Tipps, Checklisten und Best Practices von Enno & Jens.",
      path: "/ratgeber",
      image: "/images/hero-bg-1280.webp",
      imageAlt: "Ratgeber zu Webdesign und SEO von Enno & Jens",
      imageWidth: 1280,
      imageHeight: 720,
      scripts: [blogSchema(sortedInsights)],
    }),
  component: RatgeberPage,
});
